import { GraviGrid } from '@gravitate-js/excalibrr'
import { getDetailColumnDefs } from '../columnDefs'
import { ProductGroupRowRenderer } from './ProductGroupRowRenderer'
import type { DeliveryReconDetailRow, DeliveryReconOverviewRow } from '../types'

type DetailCellRendererProps = {
  data: DeliveryReconOverviewRow
  unlink: (id: DeliveryReconOverviewRow['match_id'], selected: DeliveryReconDetailRow) => Promise<void>
}

export function DetailCellRenderer({ data, unlink }: DetailCellRendererProps) {
  return (
    <div className='p-2'>
      <GraviGrid
        columnDefs={getDetailColumnDefs((detail: DeliveryReconDetailRow) => unlink(data.match_id, detail))}
        agPropOverrides={{
          className: 'delivery-rec-detail-grid',
          rowGroupPanelShow: 'never',
          getRowId: (params) => `${params.data.id}-${params.data.tank_id}`,
          groupRowRendererParams: {
            innerRenderer: ProductGroupRowRenderer,
            suppressCount: true,
          },
          context: { parentData: data },
          suppressRowGroupHidesColumns: true,
          groupDefaultExpanded: -1,
          domLayout: 'autoHeight',
        }}
        sideBar={false}
        rowData={data.details}
      />
    </div>
  )
}
